import { Injectable } from '@angular/core';
import * as _ from "lodash";
import * as legend from "../../config/legend";
import * as series from "../../config/series";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as xAxis from "../../config/xAxis";
import * as yAxis from "../../config/yAxis";
import * as color from "../../config/colors";
import * as backgroundColor from "../../config/backgroundColor";
import * as textStyle from '../../config/textStyle';
import * as datazoom from "../../config/datazoom";
import { MultiLineChartParam } from './multi-line-chart-param-interface';
import { CommonService } from '../../service/common.service';
import { EChartOption, ECharts } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { isNil } from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class MultiLineChartService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.changeFontSize();

  //   export const getOptionOfPointValueLineChart = function (basicLineChartParam: BasicLineChartParam): any {
  //     let basicLineChartOption = {
  //         color: color,
  //         backgroundColor: backgroundColor,
  //         grid: basicLineChartParam.customGrid,
  //         legend: legend.getLegendRightScroll(basicLineChartParam.style),
  //         tooltip: tooltip.getToolTipOfAxisChart(basicLineChartParam.style, basicLineChartParam.unit),
  //         toolbox: toolbox.getToolBoxBasicMenu(),
  //         xAxis: xAxis.getXaxisOfCategory(basicLineChartParam.xAxisName, basicLineChartParam.xAxisDatas),
  //         yAxis: yAxis.getYaxisOfValue(basicLineChartParam.style, basicLineChartParam.yAxisName, basicLineChartParam.yNameGap),
  //         series: series.getMoreLineChartSeries(basicLineChartParam.datas, basicLineChartParam.seriesNames)
  //     }
  //     return basicLineChartOption;
  // }
  sNameValue = tooltip;
  getDefaultOption() {
    let defaultOption = {
      color: color.defaultColors,
      backgroundColor: backgroundColor.backgroundColor,
      grid: this.style.rightLegendGrid,
      legend: legend.getLegendRightScroll(this.style),
      tooltip: tooltip.getToolTipOfAxisChart(this.style, ""),
      // toolbox: toolbox.getToolboxBasicMenu(),
      // xAxis: xAxis.getXaxisOfCategory("", [], this.style),
      xAxis: xAxis.getXaxisOfCategoryTick(this.style),
      yAxis: yAxis.getYaxisOfValue(this.style, "noise level(dB)", 30),
      series: series.getMoreLineChartSeries([], [], {}, []),
      textStyle: textStyle.getTextStyle()
    }
    return defaultOption;
  }

  setUnit(option: any, unit: string) {
    option.tooltip = tooltip.getToolTipOfAxisChart(this.style, unit);
  }

  setXaxisName(option: any, xAxisName: string) {
    option.xAxis[0].name = xAxisName;
  }

  setYaxisName(option: any, yAxisName: string) {
    option.yAxis[0].name = yAxisName;
  }

  setYnameGap(option: any, yNameGap: number) {
    option.yAxis[0].nameGap = yNameGap;
  }

  setDatas(option: any, datas: any) {

    if (datas && datas.hasOwnProperty('xAxisDatas')) {
      option.xAxis[0].data = datas.xAxisDatas;
    }

    if (datas && datas.hasOwnProperty('seryNames') && datas.seryNames) {
      option.series = series.getMoreLineChartSeries(datas.datas, datas.seryNames, datas.markArea, datas.markLine);
    }
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  setLegendPosition(option: any, legendPosition: string) {
    if (legendPosition === "top") {
      option.grid = this.style.topLegendGrid;
      option.legend = legend.getTopLegend(this.style);
    } else if (legendPosition === "bottom") {
      option.grid = this.style.interval;
      option.legend = legend.getLegendBottomScroll(this.style);
    } else if (legendPosition === 'none') {
      option.grid = this.style.noLegendGrid;
      option.legend = legend.getLegendNotShow(this.style);
    } else {
      //默认right
      option.grid = this.style.rightLegendGrid;
      option.legend = legend.getLegendRightScroll(this.style);
    }
  }
  // 修改维度名称
  changeDimensionNames(chartOption, dimensionNames: string[], units) {
    let style = this.commonService.changeFontSize();
    // let names = [], units = [];
    let names = dimensionNames;
    if (!dimensionNames) {
      return;
    }

    // for (const iterator of dimensionNames) {
    //   names.push(iterator.dimensionName)
    //   units.push(iterator.unit)
    // }

    let dimensions = ['x'];
    dimensions = dimensions.concat(names);

    chartOption.series.forEach(item => {
      item.dimensions = dimensions
    })

    // chartOption.series[0].dimensions = dimensions;


    chartOption.tooltip = tooltip.getTooltipOfAxisChartWithMultiDimension(units);
  }
  // 修改y轴最小间隔
  changeYAxisMinInterval(minInterval, chartOption) {
    chartOption.yAxis[0].minInterval = minInterval;
  }
  // min
  changeYAxisMin(chartOption, min) {
    chartOption.yAxis[0].min = min;
  }
  // max
  changeYAxisMax(chartOption, max) {
    chartOption.yAxis[0].max = max;
  }
  //interval
  changeYAxisInterval(chartOption, interval) {
    chartOption.yAxis[0].interval = interval;
  }
  //x轴label旋转
  changeXaxisLabelRotate(chartOption, xAxisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOption.xAxis[0].axisLabel.rotate = rotate;
    chartOption.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }
  //y轴label旋转
  changeYaxisLabelRotate(chartOption, yAxisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOption.yAxis[0].axisLabel.rotate = rotate;
    chartOption.yAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  // 设置x轴label的 自定截取长短的format
  setXaxisLabelFormat(chartOption, xAxisLabelFormat: number[]) {
    if (isNil(xAxisLabelFormat[0])) {
      xAxisLabelFormat[0] = 0
    }
    if (isNil(xAxisLabelFormat[1])) {
      xAxisLabelFormat[1] = 0
    }
    chartOption.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      valueText = value.slice(xAxisLabelFormat[0], xAxisLabelFormat[1]);
      return valueText;
    }
  }

}
